module.exports = __webpack_public_path__ + "static/media/129-ossetia.265e2537.svg";